export default __webpack_public_path__ + "static/media/palette.a235a13c.svg";